var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6553_35138)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7344 17.8184C13.252 17.8066 10.7676 17.8028 8.28125 17.8066C8.28125 18.2285 8.28125 18.6504 8.28125 19.0723C8.14304 19.4541 7.87351 19.6826 7.47266 19.7578C6.9412 19.7924 6.57596 19.5639 6.37695 19.0723C6.37109 18.6543 6.36914 18.2364 6.37109 17.8184C5.98638 17.8066 5.59966 17.8028 5.21094 17.8066C5.21094 15.416 5.21094 13.0254 5.21094 10.6348C5.42669 8.95949 5.63959 7.28371 5.84961 5.60742C5.93622 4.95136 6.2663 4.46113 6.83984 4.13672C7.14849 3.957 7.47271 3.81247 7.8125 3.70313C9.15818 3.26627 10.539 3.02995 11.9551 2.99414C13.5355 3.02544 15.0687 3.30864 16.5547 3.84375C16.8755 3.97871 17.1764 4.14668 17.457 4.34766C17.8545 4.66798 18.0792 5.08399 18.1309 5.5957C18.3409 7.27995 18.5558 8.96354 18.7754 10.6465C18.7947 13.0371 18.8083 15.4277 18.8164 17.8184C18.4375 17.8184 18.0586 17.8184 17.6797 17.8184C17.6817 18.2793 17.6797 18.7403 17.6738 19.2012C17.5944 19.6126 17.3503 19.8686 16.9414 19.9688C16.5361 20.0482 16.1982 19.9329 15.9277 19.623C15.8192 19.4773 15.7568 19.3132 15.7402 19.1309C15.7344 18.6934 15.7324 18.2558 15.7344 17.8184Z",
    fill: "#000A0A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10156 4.30737C11.0391 4.30542 12.9766 4.30737 14.9141 4.31323C15.159 4.39018 15.2663 4.5562 15.2363 4.81128C15.1787 4.99394 15.0556 5.10137 14.8672 5.13355C12.957 5.14136 11.0469 5.14136 9.13672 5.13355C8.91623 5.07519 8.79514 4.93261 8.77344 4.70581C8.80245 4.50507 8.91184 4.37226 9.10156 4.30737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42188 5.99487C10.5 5.99292 13.5781 5.99487 16.6563 6.00073C16.8953 6.05618 17.0457 6.20266 17.1074 6.44019C17.2821 7.80407 17.4619 9.16735 17.6465 10.53C17.6751 10.8856 17.5169 11.1024 17.1719 11.1804C13.7383 11.1882 10.3047 11.1882 6.87109 11.1804C6.57389 11.0981 6.42155 10.9028 6.41406 10.5945C6.42442 10.4555 6.4381 10.3169 6.45508 10.1785C6.63258 8.92031 6.81227 7.6625 6.99414 6.40503C7.06311 6.18955 7.20568 6.05284 7.42188 5.99487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.0021C16.5 14.5556 16.0518 15 15.499 15C14.9461 15 14.5 14.5514 14.5 14.0021C14.5 13.4528 14.9482 13 15.499 13C16.0497 13 16.5 13.4486 16.5 14.0021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.0021C9.5 14.5556 9.05183 15 8.49895 15C7.94607 15 7.5 14.5514 7.5 14.0021C7.5 13.4528 7.94817 13 8.49895 13C9.04974 13 9.5 13.4486 9.5 14.0021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6553_35138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.db004b6a5d2ae52f6f0787e96668ba22.svg";
export { ForwardRef as ReactComponent };